import { Component } from '@angular/core';
import { FormularioTitle, DatosPaciente } from '../models/paciente.model';
import { PacientesService } from '../services/pacientes.service';
import { Route, ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-crear',
  templateUrl : './../views/crear.component.html',
  styleUrls: ['./../css/formulariopaciente.component.css'],
  providers: [PacientesService]
})

export class FormularioPaciente {

    public titulo: string;
    public consultation = {
      patient: {full_name:'',rut:'',address:'',birthdate:'',occupation:'',phone:''},
      id:'',
      value:'',
      date:'',
      recipe: {
        near: {
          od: {cli:'',eje:'',esf:''},
          oi: {cli:'',eje:'',esf:''}
        },
        far: {
          od: {cli:'',eje:'',esf:''},
          oi: {cli:'',eje:'',esf:''}
        }
      },doctor:'',
      laboratory:'',
      lens_type:'',
      design: [],
      keratometry: {
        od: {a:'',b:''},
        oi: {a:'',b:''}
      },
      observations:''
    };
    private pacientesService;
    private route;
    private router;

    constructor(
        pacientesService: PacientesService,
        route: ActivatedRoute,
        router: Router
    ) {
        this.pacientesService = pacientesService;
        this.route = route;
        this.router = router;
        

    }

    ngOnInit(): void {
      // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
      // Add 'implements OnInit' to the class.
      this.titulo = 'CREAR NUEVO PACIENTE';
      

    }

    onSubmit() {
        console.log(this.consultation);
        if (!this.consultation.id) {
          this.consultation.id = ''
        }
         this.pacientesService.addPaciente(this.consultation).subscribe(
           response => {
            // window.location.href = '/editar/' + response.request.patient.id
             this.consultation.id = response.request.id
              console.log(response);
              alert('Paciente Creado con exito');
              this.router.navigate(['buscarpaciente']);

           },
           error => {
               console.log( error as any);
               alert('UPs Algo salio mal ,revise si todos los campos son correctos e intente nuevamente');
           });
    }
}
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/

